import i18n from "../../../i18n";

import {
  AUTOCOMPLETE_FIELD_TYPE,
  NUMERIC_FIELD_TYPE,
} from "../../../helpers/constants";

import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";

export const EQUIPMENT_DIFFERENTIAL_MONTH_PARAMS_TABLE_PREFIX = "edmp";

export const EQUIPMENT_DIFFERENTIAL_MONTH_PARAMS_TABLE_CONFIG = [
  {
    name: "equipment",
    getValueCallback: (rowData) => rowData.equipment_nr,
    label: i18n.t("table.epdm_table.equipment"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData.value.equipment,
      isObjectOption: true,
      optionLabelKey: "equipment_nr",
      addNewValue: false,
      multiple: true,
    }),
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "building",
    getValueCallback: (rowData) => rowData.building,
    label: i18n.t("table.epdm_table.building"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData.value.building,
      isObjectOption: true,
      optionLabelKey: "object_name",
      addNewValue: false,
      multiple: true,
    }),
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "user",
    getValueCallback: (rowData) => rowData.user,
    label: i18n.t("table.epdm_table.user"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData.value.user,
      isObjectOption: true,
      optionLabelKey: "full_name",
      addNewValue: false,
      multiple: true,
    }),
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edmp_year",
    getValueCallback: (rowData) => rowData.edmp_year,
    label: i18n.t("table.epdm_table.edmp_year"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edmp_month",
    getValueCallback: (rowData) => rowData.edmp_month,
    label: i18n.t("table.epdm_table.edmp_month"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edmp_morning_peak_value",
    getValueCallback: (rowData) => rowData.edmp_morning_peak_value,
    label: i18n.t("table.epdm_table.edmp_morning_peak_value"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edmp_afternoon_peak_value",
    getValueCallback: (rowData) => rowData.edmp_afternoon_peak_value,
    label: i18n.t("table.epdm_table.edmp_afternoon_peak_value"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edmp_rest_of_the_day_value",
    getValueCallback: (rowData) => rowData.edmp_rest_of_the_day_value,
    label: i18n.t("table.epdm_table.edmp_rest_of_the_day_value"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edmp_rush_value",
    getValueCallback: (rowData) => rowData.edmp_rush_value,
    label: i18n.t("table.epdm_table.edmp_rush_value"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edmp_norush_value",
    getValueCallback: (rowData) => rowData.edmp_norush_value,
    label: i18n.t("table.epdm_table.edmp_norush_value"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edmp_rush_hours_factor",
    getValueCallback: (rowData) => rowData.edmp_rush_hours_factor,
    label: i18n.t("table.epdm_table.edmp_rush_hours_factor"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },

  {
    name: "edmp_norush_hours_factor",
    getValueCallback: (rowData) => rowData.edmp_norush_hours_factor,
    label: i18n.t("table.epdm_table.edmp_norush_hours_factor"),
    filterType: NUMERIC_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },

  {
    name: "edit",
    getValueCallback: (rowData, onClickEdit) => (
      <ModeEditOutlineOutlined onClick={(e) => onClickEdit(rowData.id)} />
    ),
    label: i18n.t("edit"),
    filterType: null,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    allowChangeVisibility: false,
    excludedFromExport: true,
  },
];
